import React from "react";

const Pagination = ({
  remainingComments,
  hasMoreOnServer,
  visibleCommentsCount,
  isLoading,
  handleLoadMoreComments,
  isExpanded,
  INITIAL_DISPLAY_COUNT,
  handleShowLessComments,
}) => {
  return (
    <div className="comments-toggle-buttons">
      {(remainingComments > 0 ||
        (hasMoreOnServer && visibleCommentsCount > 0)) && (
        <button
          type="button"
          onClick={handleLoadMoreComments}
          disabled={isLoading}
          className="load-more-comments"
          aria-label="Load more comments"
        >
          Load more comments
        </button>
      )}

      {isExpanded && visibleCommentsCount > INITIAL_DISPLAY_COUNT && (
        <button
          type="button"
          onClick={handleShowLessComments}
          className="show-less-comments"
          aria-label="Show less"
        >
          Show less
        </button>
      )}
    </div>
  );
};

export default Pagination;
